import React, { Component } from "react";
import {
  Table,
  Button,
  Form,
  Radio,
  Select,
  Modal,
  message,
  InputNumber,
} from "antd";
import debtsImg from "../../assets/debts.png";
import { FaSave, FaTimes, FaPlus, FaArrowRight, FaArrowLeft, FaTrash, FaPen } from "react-icons/fa";
import DeleteModal from "../DeleteModal/DeleteModal";
import { GetAllFinancingAgencies } from "../../network/profile.network";
import { AddOrUpdateIndebtedness, DeleteIndebtedness, GetFinancingRequestDetails } from "../../network/customer.network";
import { setUserRequest } from "../../redux/user/user.action";
import { connect } from "react-redux";

const { Option } = Select;
const {confirm} = Modal;

class Debtsdata extends Component {
  state = {
    depetShow: "empty",
    showDltModal : false,
    financingAgencies : [],
    debts : [],
    inputLoading : false,
    isEdit : false,
    dltId : false,
    tableLoading : false,
    FinancingRequestDetails : null
  };

  componentDidMount() {
    GetAllFinancingAgencies((res) => {
      this.setState({financingAgencies: res.data.model})
    }, (err) => {
      // console.log(err)
    })
    if(this.props.showAdd){
      this.setState({depetShow : "list"});
    }else{
      if(this.props.userRequest?.Indebtednesses){
        this.setState({ FinancingRequestDetails : this.props.userRequest, depetShow : "list"}) 
      }
    }
    this.handelGetFinancingRequestDetails();
}

handelGetFinancingRequestDetails = () => { 
  const {userRequest, orderId} = this.props;
  this.setState({tableLoading : true})
  GetFinancingRequestDetails(orderId ? orderId :userRequest?.Id, (res) => { 
    this.setState({FinancingRequestDetails : res.data.model, tableLoading : false});
    this.props.dispatch(setUserRequest(res.data.model));
  }, (err) => { 
    // console.log(err);
    this.setState({tableLoading : false})  
  })
}
  
  itemRender = (current, type, originalElement) =>  {
    if (type === 'prev') {
      return <a className="prev-page-btn pagin-page-btn"><FaArrowRight />  الصفحة السابقة </a>;
    } 
    if (type === 'next') { 
      return <a className="next-page-btn pagin-page-btn">الصفحة التاليه  <FaArrowLeft /> </a>;
    }
    return originalElement;
  }

  handleDeleteCharge = (e, record) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({showDltModal : true, dltId : record.Id});
};

closeDltModal = () => { 
  this.setState({showDltModal : false})
}

  handelAddOrUpdateIndebtedness = (values) => {
    this.setState({inputLoading: true})
    const {userRequest, orderId} = this.props; 
    let body = {...values,
      FinancingRequestId: orderId ? orderId : userRequest?.Id,
      // Id: orderId ? orderId : userRequest?.Id,
    };
    if(this.state.isEdit){
      body.Id = this.state.isEdit.Id;
    }
    //console.log(body)
    AddOrUpdateIndebtedness(body, (res) => {
      if(this.state.isEdit){
        message.success("تم تعديل المديونيه بنجاح");
      }else{
        message.success("تم اضافه المديونيه بنجاح");
      }
      this.setState({inputLoading: false, depetShow : "list", isEdit : false})
      this.handelGetFinancingRequestDetails();
    }, (err) => {
      this.setState({inputLoading: false})
      // console.log(err);
    })
  }

  handeldeleteDebets = () => {
    const {dltId} = this.state;
    this.setState({tableLoading : true})
    DeleteIndebtedness(
      dltId,
      (res) => {
        message.success("تم حذف المديونية بنجاح");
        this.handelGetFinancingRequestDetails(); 
      },
      (error) => {
        this.setState({tableLoading : false})
        message.error("المديونية غير موجودة");
        //console.log(error);
      }
    );
  };

  render() {
    const { depetShow, tableLoading, showDltModal,
      financingAgencies, inputLoading, FinancingRequestDetails, isEdit } = this.state;
    const { IndebtednessTypes, showAdd,  } = this.props;
    return (
      <div className="finance-tab-content">
        <Form id="orderForm2"
          onFinish={this.props.submitForm}
        >
        </Form>
        {showDltModal && <DeleteModal delete={this.handeldeleteDebets} name="المديونيه" closeDltModal={this.closeDltModal} /> }

        {depetShow === "empty" && (
          <div className="empty-depts-holder">
            <h2 className="tab-title">المديونيات</h2>
            <div className="empty-content">
              <img src={debtsImg} alt="" />
              <h3 className="empty-title">لا يوجد مديونيات</h3>
              <p className="empty-p">
                ان كانت لديك اي مديونيات فضلا قم باضافتها
              </p>
              <div className="empty-btns">
                <Button
                  type="primary"
                  size="large"
                  className="blue-btn"
                  onClick={() => this.setState({ depetShow: "add" })}
                >
                  {" "}
                  اضافه مديونيه
                </Button>
                <Button
                  type="primary"
                  size="large"
                  ghost
                  className="blue-btn"
                  onClick={this.props.nextStep}
                >
                  {" "}
                  تخطي الاضافه{" "}
                </Button>
              </div>
            </div>
          </div>
        )}

        {depetShow === "list" && (
          <div className="depts-list-holder">
            <div className="depts-header">
              <h2 className="tab-title">المديونيات</h2>
              <p className="depts-add-btn" onClick={() => this.setState({depetShow : "add", isEdit : false}) }>
              <FaPlus /> إضافه مديونيه جديده 
              </p>
            </div>
            <div className={`debt-table-summry-wrapper ${showAdd && 'debt-client'}`}>
            <Table
                    loading={tableLoading} 
                    pagination={{ simple : true, itemRender : this.itemRender }}  
                    onRow={(record, rowIndex) => {
                        return {
                        onClick: event => {
                            //console.log(record)
                            this.setState({isEdit : record, depetShow : "add"})
                        }  
                        };
                    }}
                    // rowKey = "id" 
                    className="table-roles-wrapper app-table-wrapper table-hover-wrapper debt-table"
                    columns={[
                        {
                            title: `جهه التمويل`,
                            render: (text, record) => (
                              <div>
                                {record?.FinancingAgency?.NameLT}
                              </div>
                          ),
                        }, 
                        {
                            title: `المبلغ المتبقي`, 
                            dataIndex: 'RemainingAmount',
                        },
                        {
                            title: `الاستقطاع الشهري`,
                            dataIndex: 'MonthlyPayment',
                        },
                        {
                            title: `متعثر`,
                            dataIndex: 'UnableToRepay',
                            render: (text, record) => (
                              <div>
                                {record.UnableToRepay ? "نعم" : "لا"}
                              </div>
                          ),
                        },
                        {
                            title: `نوع المديونية`, 
                            dataIndex: 'lastorder',
                            render: (text, record) => (
                              <div>
                                {record?.IndebtednessType?.NameLT}
                              </div>
                          ),
                        },
                          // {
                          //   title: 'اجراءت',  
                          //   key: 'action',
                          //   render: (text, record) => (
                          //       <i className="dlt-icon" onClick={(e) => this.handleDeleteCharge(e, record)}>
                          //         <FaTrash />
                          //       </i>
                          //   ),
                          // },
                    ]}
                    dataSource={FinancingRequestDetails?.Indebtednesses}
                />
                <div className="table-summary-holder">
                  <h3>
                  إجمالي المديونيات
                  </h3>
                  <h3> {FinancingRequestDetails?.TotalIndebtednesses}{' '} <span>ر.س</span></h3>
                </div>
                </div>
          </div>
        )}

        {depetShow === "add" && (
          <div className="add-depts-holder">
            <h2 className="tab-title">اضافه مديونيه جديده</h2>
            <Form
              className="form-add-content"
              layout="vertical"
              name="nest-messages"
              onFinish={this.handelAddOrUpdateIndebtedness}
              id="orderForm"
              initialValues={{
                FinancingAgencyId : isEdit.FinancingAgencyId,
                RemainingAmount : isEdit.RemainingAmount,
                MonthlyPayment : isEdit.MonthlyPayment,
                UnableToRepay : isEdit.UnableToRepay,
                IndebtednessTypeId : isEdit.IndebtednessTypeId, 
              }}
            >
              <div className="form-content">
                <Form.Item
                  label="جهة التمويل"
                  name="FinancingAgencyId"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "الرجاء اختيار جهة التمويل",
                    },
                  ]}
                >
                  <Select>
                    {financingAgencies.map((agency)=>{
                      return(<Select.Option key={agency.Id} value={agency.Id}>{agency.NameLT}</Select.Option>)
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  label=" المبلغ المتبقي"
                  name="RemainingAmount"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: 'من فضلك ادخل المبلغ المتبقي',
                    },
                  ]}
                >
                  <InputNumber placeholder="" />
                </Form.Item>
                <Form.Item
                  label="الاستقطاع الشهري"
                  name="MonthlyPayment"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: 'من فضلك اختر الاستقطاع الشهري',
                    },
                  ]}
                >
                <InputNumber placeholder="" /> 
                </Form.Item>
                <Form.Item
                  label="نوع المديونية"
                  name="IndebtednessTypeId"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: 'من فضلك اختر نوع المديونية',
                    },
                  ]}
                >
                  <Select>
                  {IndebtednessTypes.map((agency)=>{
                      return(<Select.Option key={agency.Id} value={agency.Id}>{agency.NameLT}</Select.Option>)
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="متعثر"
                  name="UnableToRepay"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: 'من فضلك اختر متعثر',
                    },
                  ]}
                >
                  <Radio.Group name="radiogroup">
                    <Radio value={true}>نعم</Radio>
                    <Radio value={false}>لا</Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
              <div className="form-btns-action">
                {isEdit ? 
                <Button
                htmlType="submit"
                size="large"
                className="blue-btn xlg"
                type="primary"
                loading={inputLoading}
                >
                  <FaPen />
                  تعديل
                </Button> :
                <Button
                htmlType="submit"
                size="large"
                className="blue-btn xlg"
                type="primary"
                loading={inputLoading}
                >
                  <FaSave />
                  اضافه
                </Button>
                }
                <Button
                  className="red-btn xlg"
                  size="large"
                  type="primary" 
                  onClick={() => this.setState({ depetShow : "list", isEdit : false })}
                >
                  <FaTimes />
                  الغاء
                </Button>
              </div>
            </Form>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    currentUser : state.user.currentUser,
    currentLang : state.user.currentLang,
    userRequest : state.user.userRequest,
    IndebtednessTypes : state.user.metaData.IndebtednessTypes, 
}) 
  
export default connect(mapStateToProps)(Debtsdata);  
